import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { InvestigationInvolvedEmployeeEntity } from '../../../domain/entities/investigation-involved-employee.entity';

export interface GetInvestigationInvolvedEmployeesQuery { investigationId: string; }
export interface GetInvestigationInvolvedEmployeesResult { employees: InvestigationInvolvedEmployeeEntity[]; }

@Injectable({ providedIn: 'root' })
export class GetInvestigationInvolvedEmployeesUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationInvolvedEmployeesQuery): Observable<GetInvestigationInvolvedEmployeesResult> {
    this._state.setLoadingInvolvedEmployees(true);
    this._state.setErrorInvolvedEmployees(null);
    return this._repository.getInvolvedEmployees(query.investigationId).pipe(
      tap((employees) => { this._state.setInvolvedEmployees(employees); this._state.setLoadingInvolvedEmployees(false); }),
      map((employees) => ({ employees })),
      catchError((error) => { this._state.setErrorInvolvedEmployees(error.message || 'Failed to load involved employees'); this._state.setLoadingInvolvedEmployees(false); return throwError(() => error); }),
    );
  }
}
